
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 15 14","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M11.175.63H4.318a2.939 2.939 0 00-2.94 2.94v6.856a2.939 2.939 0 002.94 2.94h6.857a2.939 2.939 0 002.939-2.94V3.57A2.939 2.939 0 0011.174.63z","stroke":"#fff","stroke-width":".98","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M4.805 7.977l2.008 1.607a.47.47 0 00.392.098.49.49 0 00.333-.235l3.144-5.388","stroke":"#fff","stroke-width":".98","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    